// Utility functions for rating calculations

export interface RatingStats {
  p: number;
  'p+': number;
  'p++': number;
  'p*': number;
  total: number;
}

/**
 * Calculate rating statistics from an array of ratings
 * @param ratings Array of ratings
 * @returns RatingStats object with counts for each rating type
 */
export function calculateRatingStats(ratings: any[]): RatingStats {
  const stats: RatingStats = {
    p: 0,
    'p+': 0,
    'p++': 0,
    'p*': 0,
    total: 0
  };

  if (!ratings || !Array.isArray(ratings)) {
    return stats;
  }

  ratings.forEach(rating => {
    if (rating.is_active !== false && rating.rating_value in stats) {
      stats[rating.rating_value as keyof RatingStats]++;
      stats.total++;
    }
  });

  return stats;
}

/**
 * Get display text for rating value
 * @param value Rating value (p, p+, p++, p*)
 * @returns Display text for the rating
 */
export function getRatingDisplayText(value: string): string {
  const mapping: Record<string, string> = {
    'p': 'Poor / Basic',
    'p+': 'Good',
    'p++': 'Very Good',
    'p*': 'Excellent / Star Performer'
  };
  
  return mapping[value] || value;
}